export const MY_INVITATIONS_KEYS = {
  all: ['my-invitations'] as const,
  byToken: (token: string) => ['my-invitations', 'token', token] as const,
};
